import { createStore, useStore } from "zustand";

import { type UnmetOrderMinimum } from "~/utils/order-minimum/get-unmet-order-minimums";

type OrderMinimumBlockState = {
  products: UnmetOrderMinimum[];
};

export const orderMinimumBlockStore = createStore<OrderMinimumBlockState>()(
  () => ({ products: [] })
);

export const orderMinimumBlockActions = {
  block: (products: UnmetOrderMinimum[]) => {
    orderMinimumBlockStore.setState({ products });
  },
  clear: () => {
    orderMinimumBlockStore.setState({ products: [] });
  }
};

export const useOrderMinimumBlock = () =>
  useStore(orderMinimumBlockStore, (state) => state.products);
